"use client";
import {
  usePopoverHeading
} from "../__chunks/4FY2MBIB.js";
import "../__chunks/6FZVKQWP.js";
import "../__chunks/OYB5INBF.js";
import {
  SelectHeadingContext
} from "../__chunks/KZ2S4ZC5.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import {
  useId,
  useSafeLayoutEffect
} from "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import {
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/select/select-heading.tsx
import { useContext } from "react";
var TagName = "h1";
var useSelectHeading = createHook(
  function useSelectHeading2(props) {
    const [, setHeadingId] = useContext(SelectHeadingContext) || [];
    const id = useId(props.id);
    useSafeLayoutEffect(() => {
      setHeadingId == null ? void 0 : setHeadingId(id);
      return () => setHeadingId == null ? void 0 : setHeadingId(void 0);
    }, [setHeadingId, id]);
    props = __spreadValues({
      id
    }, props);
    props = usePopoverHeading(props);
    return props;
  }
);
var SelectHeading = forwardRef(function SelectHeading2(props) {
  const htmlProps = useSelectHeading(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectHeading,
  useSelectHeading
};
